







import { Component, Watch, Mixins } from "vue-property-decorator";
import { ClientRoutes } from "@/data/enums/router";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

@Component({
  components: {
    "cprod-messages": () =>
      import(`@/components/app/global/contractProducts/cProdMessages.vue`)
  }
})
export default class ClientCProd extends Mixins(CProdInjectorMixin) {
  /**
   * @name onNameChange
   * @desc Here we monitor the contract product name and commit it to the UI
   * store so it can be used and shown within the document page title etc.
   */

  @Watch("cProdData.name", { immediate: true })
  public onNameChange(cProdName) {
    this.$store.commit("ui/setMetaProps", {
      cProdName: cProdName || this.$t("_.product")
    });
  }

  /**
   * @name onLoadingChange
   * @desc Here we monitor the loading state of the cProdProvider, and when
   * ready (and IF on the parent route), we determine where to redirect the
   * user to; either the cProd overview or setup view.
   */

  @Watch("cProdData.isLoading", { immediate: true })
  public onLoadingChange(isLoading: boolean, wasLoading: boolean) {
    if (wasLoading && !isLoading && !!this.cProdData.contract) {
      if (this.$route?.name !== ClientRoutes.CONTRACT_PRODUCT) return;
      return this.$router
        .replace({
          name: this.cProdData.isAwaitingSetup
            ? ClientRoutes.CONTRACT_PRODUCT_SETUP
            : ClientRoutes.CONTRACT_PRODUCT_OVERVIEW,
          params: {
            doBusReload: false as any
          }
        })
        .catch(err => err);
    }
  }

  // Life-cycle methods

  public beforeDestroy() {
    this.$store.commit("ui/unsetMetaProps", ["cProdName"]);
  }
}
